import { render, staticRenderFns } from "./MandateConformityBanner.vue?vue&type=template&id=32093982&scoped=true&"
import script from "./MandateConformityBanner.vue?vue&type=script&lang=js&"
export * from "./MandateConformityBanner.vue?vue&type=script&lang=js&"
import style0 from "./MandateConformityBanner.vue?vue&type=style&index=0&id=32093982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32093982",
  null
  
)

export default component.exports